// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__22tMq","errors":"Errors_errors__2Z-uQ"};